import React, {memo, useState} from "react";
import {
    Checkbox,
    Icon,
    IconButton,
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem,
    TableHead,
    TableRow,
    TableCell,
    TableSortLabel
} from "@material-ui/core";
import LightTooltip from "../../../../components/LigthTooltip";
import moment from "moment";


const cells = [
    {
        id: 'service_name',
        sortId: 2,
        align: 'left',
        disablePadding: false,
        label: 'Название услуги',
        sort: true
    },
    {
        id: 'provider_name',
        sortId: 3,
        align: 'left',
        disablePadding: false,
        label: 'Поставщик услуги',
        sort: true
    },
    {
        id: 'session_date',
        sortId: 1,
        align: 'left',
        disablePadding: false,
        label: 'Дата и время начала',
        sort: true
    },
    {
        id: 'status_name',
        sortId: 4,
        align: 'left',
        disablePadding: false,
        label: 'Статус',
        sort: true
    }
];

const mobileCells = [
    {
        id: 'service_name',
        sortId: 2,
        align: 'left',
        disablePadding: false,
        label: 'Название услуги',
        sort: true
    },
    {
        id: 'session_date',
        sortId: 1,
        align: 'left',
        disablePadding: false,
        label: 'Дата и время',
        sort: true
    }
]
  
const ServicesTableHead = ({
    isMobile,
    selectedServices,
    services,
    order,
    onSelectAll,
    onSort,
    onCancelServices
}) => {
    const [selectedServicesMenu, setSelectedServicesMenu] = useState(null);
    const selectedCount = selectedServices.length;
    const availableServices = services.filter(service => moment().isBefore(service.session_date) && service.status_id !== 8);

    const handleMenuOpen = e => {
        setSelectedServicesMenu(e.currentTarget);
    };

    const handleMenuClose = () => {
        setSelectedServicesMenu(null);
    };

    const handleCancelServices = () => {
        onCancelServices();
        handleMenuClose();
    };

    const checkIsChecked = () => {
        let isChecked = !!selectedServices.length;

        if(availableServices.length) {
            availableServices.forEach(service => {
                if(!selectedServices.find(item => item.id === service.id)) {
                    isChecked = false;
                }
            });
        } else {
            isChecked = false;
        }

        return isChecked;
    };

    return (
        <TableHead className="services-table__head">
            <TableRow className="services-table__row">
                <TableCell padding="none" className="services-table__cell">
                    <Checkbox
                        indeterminate={selectedCount > 0 && !checkIsChecked()}
                        checked={checkIsChecked()}
                        disabled={!availableServices.length}
                        onChange={onSelectAll}
                    />
                </TableCell>
                {!isMobile &&
                    <TableCell padding="none" className="services-table__cell">
                        <div className="services-table__menu menu-desktop">
                            <IconButton
                                aria-owns={selectedServicesMenu ? 'selectedServicesMenu' : null}
                                aria-haspopup="true"
                                onClick={handleMenuOpen}
                                disabled={!selectedCount}
                            >
                                <Icon>more_horiz</Icon>
                            </IconButton>
                            <Menu
                                id="selectedServicesMenu"
                                anchorEl={selectedServicesMenu}
                                open={!!selectedServicesMenu}
                                onClose={handleMenuClose}
                            >
                                <MenuItem onClick={handleCancelServices}>
                                    <ListItemIcon><Icon>block</Icon></ListItemIcon>
                                    <ListItemText primary="Отменить"/>
                                </MenuItem>
                            </Menu>
                        </div>
                    </TableCell>
                }
                {isMobile ?
                    <>
                        {mobileCells.map(mobileCell =>
                            <TableCell
                                className="services-table__cell"
                                key={mobileCell.id}
                                align={mobileCell.align}
                                padding={mobileCell.disablePadding ? 'none' : 'normal'}
                                sortDirection={order.id === mobileCell.id ? order.direction : false} //asc, desc, false
                            >
                                {mobileCell.sort &&
                                    <LightTooltip
                                        title="Сортировать"
                                        placement={mobileCell.align === 'right' ? 'bottom-end' : 'bottom-start'}
                                        enterDelay={300}
                                    >
                                        <TableSortLabel
                                            className='typografhy'
                                            active={order.id === mobileCell.id}
                                            direction={order.direction}
                                            onClick={() => onSort(mobileCell.id, mobileCell.sortId)}
                                        >
                                            {mobileCell.label}
                                        </TableSortLabel>
                                    </LightTooltip>
                                }
                            </TableCell>
                        )}
                        <TableCell className="services-table__cell">
                            <div className="services-table__menu">
                                <IconButton
                                    aria-owns={selectedServicesMenu ? 'selectedServicesMenu' : null}
                                    aria-haspopup="true"
                                    onClick={handleMenuOpen}
                                    disabled={!selectedCount}
                                >
                                    <Icon>more_horiz</Icon>
                                </IconButton>
                                <Menu
                                    id="selectedServicesMenu"
                                    anchorEl={selectedServicesMenu}
                                    open={!!selectedServicesMenu}
                                    onClose={handleMenuClose}
                                >
                                    <MenuItem onClick={handleCancelServices}>
                                        <ListItemIcon><Icon>block</Icon></ListItemIcon>
                                        <ListItemText primary="Отменить"/>
                                    </MenuItem>
                                </Menu>
                            </div>
                        </TableCell>
                    </> :
                    cells.map(cell =>
                        <TableCell
                            className="services-table__cell"
                            key={cell.id}
                            align={cell.align}
                            padding={cell.disablePadding ? 'none' : 'normal'}
                            sortDirection={order.id === cell.id ? order.direction : false} //asc, desc, false
                        >
                            {cell.sort &&
                                <LightTooltip
                                    title="Сортировать"
                                    placement={cell.align === 'right' ? 'bottom-end' : 'bottom-start'}
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={order.id === cell.id}
                                        direction={order.direction}
                                        onClick={() => onSort(cell.id, cell.sortId)}
                                    >
                                        {cell.label}
                                    </TableSortLabel>
                                </LightTooltip>
                            }
                        </TableCell>
                    )
                }
            </TableRow>
        </TableHead>
    )
};

export default memo(ServicesTableHead);